
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Materials from "../pages/materials/page";
import MaterialDetail from "../pages/material-detail/page";
import Homework from "../pages/homework/page";
import Admin from "../pages/admin/page";
import Login from "../pages/login/page";
import Register from "../pages/register/page";
import Profile from "../pages/profile/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/materials",
    element: <Materials />,
  },
  {
    path: "/materials/:id",
    element: <MaterialDetail />,
  },
  {
    path: "/homework",
    element: <Homework />,
  },
  {
    path: "/admin",
    element: <Admin />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/register",
    element: <Register />,
  },
  {
    path: "/profile",
    element: <Profile />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
